export default __webpack_public_path__ + "static/media/perrotips_footer.68f01dec.jpg";